import {useMutation, useQueryClient} from "react-query";
import {Loss} from "../models/types";
import {deleteLoss} from "../restapi/loss";

export function useDeleteLoss() {
    const queryClient = useQueryClient();

    return useMutation<boolean, Error, Loss>(
        (loss: Loss) => deleteLoss(loss),
        {
            onSuccess: () => {
                queryClient.invalidateQueries(['losses']);
            }
        }
    );
}
